import { gql } from '@apollo/client';

const TAG_FRAGMENT = gql`
  fragment BaseTag on Tag {
    id
    tagGroup
    value
  }
`;

export default TAG_FRAGMENT;
